"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = __importDefault(require("./app"));
const router_1 = __importDefault(require("./router"));
require("@/styles/reset.module.css");
require("@/styles/styles.css");
const highlight_js_1 = __importDefault(require("highlight.js"));
const javascript_1 = __importDefault(require("highlight.js/lib/languages/javascript"));
const css_1 = __importDefault(require("highlight.js/lib/languages/css"));
const xml_1 = __importDefault(require("highlight.js/lib/languages/xml"));
highlight_js_1.default.registerLanguage("javascript", javascript_1.default);
highlight_js_1.default.registerLanguage("css", css_1.default);
highlight_js_1.default.registerLanguage("html", xml_1.default);
new app_1.default(document.getElementById("app"));
// 끝 슬래시 제거
const normalizePath = (pathname) => {
    if (pathname === "/")
        return "/";
    return pathname.replace(/\/+$/, "");
};
// 최초 진입 시 정규화 (히스토리 오염 방지: replaceState)
(() => {
    const p = normalizePath(location.pathname);
    if (p !== location.pathname)
        history.replaceState(null, "", p + location.search + location.hash);
})();
window.addEventListener("popstate", () => {
    (0, router_1.default)();
});
document.addEventListener("click", (e) => {
    const a = e.target.closest("a[data-link]");
    if (!a)
        return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === "_blank")
        return;
    e.preventDefault();
    const url = new URL(a.getAttribute("href"), location.origin);
    const nextPath = normalizePath(url.pathname);
    if (nextPath !== location.pathname || url.search || url.hash) {
        history.pushState(null, "", nextPath + url.search + url.hash);
        (0, router_1.default)().then(() => window.scrollTo(0, 0));
    }
});
(0, router_1.default)();
